module.exports = __webpack_public_path__ + "img/3er.cc0ba9b5.png";